import { gql, TypedDocumentNode } from "@apollo/client";

import {
  PopulateUserSampleTemplatesMutation,
  PopulateUserSampleTemplatesMutationVariables,
} from "./PopulateUserSampleTemplates.generated";

export const POPULATE_USER_SAMPLE_TEMPLATES: TypedDocumentNode<
  PopulateUserSampleTemplatesMutation,
  PopulateUserSampleTemplatesMutationVariables
> = gql`
  mutation PopulateUserSampleTemplates {
    populateUserSampleTemplates {
      ok
    }
  }
`;
